export class CostDataRecord {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "recordTimeFrame",
            "baseName": "recordTimeFrame",
            "type": "TimeFrame",
            "format": ""
        },
        {
            "name": "resourceCount",
            "baseName": "resourceCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "dimensions",
            "baseName": "dimensions",
            "type": "CostDataRecordDimensions",
            "format": ""
        },
        {
            "name": "costs",
            "baseName": "costs",
            "type": "Array<CostDataRecordCost>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CostDataRecord.attributeTypeMap;
    }
    constructor() {
    }
}
